import { render, staticRenderFns } from "./PersonalDocumentForm.vue?vue&type=template&id=02acc958&scoped=true&"
import script from "./PersonalDocumentForm.vue?vue&type=script&lang=js&"
export * from "./PersonalDocumentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02acc958",
  null
  
)

export default component.exports